import { Portal } from "@design-system/components/Portals";
import { trans } from "@mongez/localization";
import { unlockCodePortal } from "../../atoms/unlock-code.atom";
import { UnlockCodeForm } from "../UnlockCodeForm/UnlockCodeForm";

export function UnlockCodePortal() {
  return (
    <Portal
      portal={unlockCodePortal}
      width="sm"
      closeButton
      overlay
      clickOutside
    >
      <div className="max-h-[80vh] space-y-6 overflow-y-auto">
        <>
          <div className="text-center">
            <h2 className="mb-2 text-2xl font-bold text-gray-900 dark:text-gray-100">
              {trans("unlockCode.title")}
            </h2>
            <p className="text-gray-600 dark:text-gray-300">{trans("unlockCode.description")}</p>
          </div>

          <UnlockCodeForm />
        </>
      </div>
    </Portal>
  );
}
